module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contact-wrapper"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "concern"
  }, [_c('h2', [_c('Icon', {
    attrs: {
      "type": "heart"
    }
  }), _vm._v("  关注我们")], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/icon/qrcode.png"),
      "title": "关注我们",
      "alt": "关注我们",
      "width": "150"
    }
  })])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("广告服务")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://gjypzc.taobao.com/"
    }
  }, [_vm._v("纸质入口")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("诚聘英才")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("用户指南")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("联系我们")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('ol', [_c('li', {
    staticClass: "addr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon/location.png")
    }
  }), _vm._v("广州市白云区云城街机场路1718号631室\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "mobile"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon/phone.png")
    }
  }), _vm._v("\n                        020-37737622\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "wechat"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon/wechat.png")
    }
  }), _vm._v("\n                        fairy4802004\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "qq"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon/QQ.png")
    }
  }), _vm._v("\n                        3137597228\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon/email.png")
    }
  }), _vm._v("\n                        gjypzc@qq.com\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright-text"
  }, [_c('p', [_vm._v("Copyright © 广州佳鑫医药科技有限公司")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.miitbeian.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备17013101号-1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f0dba0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 491
// module chunks = 15